import { apiFetch } from '@/platform/lib/api';

export type PaydirtProductStats = {
  productId: string;
  haulCount: number;
  avgMetalsTroyOzPerPurchase: number;
  avgMetalsValueUsdPerPurchase: number;
  avgPreciousGemCaratsPerPurchase: number;
  avgSemiPreciousGramsPerPurchase: number;
};

export function getPaydirtProductStats(vendorId: string, productId: string) {
  return apiFetch<PaydirtProductStats>(`/vendors/${vendorId}/products/${productId}/paydirt-stats`);
}
